import { useState } from "react";

import * as Services from "../services/creatorsService";

const parseCreators = (response) => {
  if (Array.isArray(response?.creators)) {
    return response.creators;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  if (Array.isArray(response)) {
    return response;
  }

  return [];
};

const parseCreator = (response) => {
  return response?.creator ?? response?.data ?? response ?? null;
};

export const useCreators = (userId) => {
  const [creators, setCreators] = useState([]);
  const [creator, setCreator] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const getCreators = async () => {
    if (!userId) {
      setCreators([]);
      return [];
    }

    try {
      setLoading(true);
      setError("");

      const response = await Services.getCreators(userId);

      const items = parseCreators(response);

      setCreators(items);

      return items;
    } catch (error) {
      console.error("getCreators failed:", error);

      setCreators([]);

      setError(
        error?.response?.data?.message || "Unable to load creator profiles.",
      );

      return [];
    } finally {
      setLoading(false);
    }
  };

  const getCreator = async (username) => {
    if (!username) {
      setCreator(null);
      return null;
    }

    try {
      setLoading(true);
      setError("");

      const response = await Services.getCreator({ username });

      const item = parseCreator(response);

      setCreator(item);

      return item;
    } catch (error) {
      console.error("getCreator failed:", error);

      setCreator(null);

      setError(
        error?.response?.data?.message || "Unable to load creator profile.",
      );

      return null;
    } finally {
      setLoading(false);
    }
  };

  const clearCreators = () => {
    setCreators([]);
    setError("");
  };

  const clearCreator = () => {
    setCreator(null);
    setError("");
  };

  return {
    creators,
    creator,

    loading,
    error,

    getCreators,
    getCreator,

    clearCreators,
    clearCreator,

    setCreators,
    setCreator,
    setError,
  };
};

export default useCreators;
